"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("../Sidebar/styles");

var _styles2 = require("../../NavigationRail/styles");

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      zIndex: 1
    },
    pageInner: {
      fontFamily: theme.typography.body1.fontFamily
    },
    contentWrap: {
      display: "flex",
      flexDirection: "column",
      flexGrow: "1",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      boxSizing: "border-box",
      overflow: "auto"
    },
    hasSidebar: (0, _defineProperty2.default)({}, theme.breakpoints.up("md"), {
      left: "".concat(_styles.mainPanelWidth, "px")
    }),
    hasNavigationRail: {
      left: _styles2.navigationRailWidth
    },
    hasTopbar: (0, _defineProperty2.default)({
      top: theme.mixins.toolbar.minHeight
    }, theme.breakpoints.up("sm"), {
      top: theme.mixins.toolbar.minHeight + theme.spacing(3.5)
    }),
    content: (0, _defineProperty2.default)({
      margin: theme.spacing(4) + "px"
    }, theme.breakpoints.up("md"), {
      margin: theme.spacing(8) + "px"
    }),
    main: {
      display: "flex",
      flexDirection: "column",
      flexGrow: "1"
    },
    "@global body": {
      fontFamily: theme.typography.fontFamily,
      backgroundColor: theme.palette.background.default
    },
    offsetTopBar: (0, _defineProperty2.default)({
      position: "absolute",
      top: theme.mixins.toolbar.minHeight + theme.spacing(3.5),
      height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight + theme.spacing(3.5), "px)")
    }, theme.breakpoints.down("xs"), {
      top: theme.mixins.toolbar.minHeight,
      height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight, "px)")
    })
  };
};

exports.styles = styles;